import { render, staticRenderFns } from "./PoolChooserStandard.vue?vue&type=template&id=740b8bdc"
import script from "./PoolChooserStandard.vue?vue&type=script&lang=ts"
export * from "./PoolChooserStandard.vue?vue&type=script&lang=ts"
import style0 from "./PoolChooserStandard.vue?vue&type=style&index=0&id=740b8bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports